<template>
  <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" @click.self="$emit('close')">
    <div class="bg-white rounded-lg p-6 max-w-2xl w-full max-h-[90vh] overflow-y-auto">
      <div class="flex justify-between items-start mb-4">
        <h2 class="text-xl font-bold">Alert Details</h2>
        <button @click="$emit('close')" class="text-gray-500 hover:text-gray-700">
          <XMarkIcon class="w-6 h-6" />
        </button>
      </div>
      
      <div class="space-y-4">
        <div>
          <h3 class="font-semibold">{{ alert.title || 'Alert' }}</h3>
          <p class="text-gray-600">{{ alert.message }}</p>
        </div>
        
        <div class="grid grid-cols-2 gap-4">
          <div>
            <span class="text-sm text-gray-500">Severity:</span>
            <span :class="['ml-2 badge', getSeverityClass(alert.severity)]">{{ alert.severity }}</span>
          </div>
          <div>
            <span class="text-sm text-gray-500">Status:</span>
            <span class="ml-2">{{ alert.status }}</span>
          </div>
        </div>
        
        <div class="flex space-x-2">
          <button v-if="alert.status === 'active'" @click="$emit('acknowledge', alert)" class="btn btn-primary">
            Acknowledge
          </button>
          <button @click="$emit('resolve', alert)" class="btn btn-success">
            Resolve
          </button>
          <button @click="$emit('dismiss', alert)" class="btn btn-secondary">
            Dismiss
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { XMarkIcon } from '@heroicons/vue/24/outline'

defineProps({
  alert: {
    type: Object,
    required: true
  }
})

defineEmits(['close', 'acknowledge', 'resolve', 'dismiss'])

function getSeverityClass(severity) {
  const classes = {
    critical: 'badge-danger',
    high: 'badge-warning',
    medium: 'badge-info',
    low: 'badge-success'
  }
  return classes[severity] || 'badge-secondary'
}
</script>